import React from "react";
import DigitBadge from "../DigitBadge/DigitBadge";
import "./Timeline.css";
import checkronRight from "../../images/chevron-right.svg";

const Timeline = ({ onTitleClick, timelineItems, timelineItemStatus }) => {
  return (
    <div
      className="timeline"
      style={{ display: "flex", flexDirection: "column", gap: "24px" }}
    >
      {timelineItems.map((item, index) => {
        return (
          <div className="timeline-element" key={item.id}>
            <div
              className="flex-center"
              style={{
                zIndex: 8,
              }}
              // onClick={() => onItemClick(item.id)}
            >
              <DigitBadge
                digit={index + 1}
                badgeColor={
                  timelineItemStatus?.[item.id] ? "#65A30D" : "#DBDBDB"
                }
                digitColor={
                  timelineItemStatus?.[item.id] ? "#65A30D" : "#999999"
                }
                bgColor="#F1F2F2"
              />
            </div>

            <div
              className="timeline-element-content"
              onClick={() => onTitleClick(item.id)}
              style={{
                cursor: item?.titleAction ? "pointer" : "default",
              }}
            >
              <div>
                <p
                  className={`timeline-title ${timelineItemStatus?.[item.id] ? "timeline-title--complete" : "timeline-title--incomplete"}`}
                >
                  {item.title}
                </p>
                {/* <p className="timeline-subtitle">{item.subTitle}</p> */}
              </div>
              <div className="flex-center timeline-arrow">
                <img
                  alt="getting-started-details"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    item?.onArrowClick && item?.onArrowClick(true, item.details)
                  }
                  height={20}
                  width={20}
                  src={checkronRight}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Timeline;
